import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { GoogleAnalyticsService } from 'ngx-google-analytics';
import { StorageService } from '../../services/storage.service';
import { User } from '../../interface/user';
import { AuthService } from '../../services/auth.service';
declare let Ybug: any;
@Injectable()
export class AnalyticsService {
  currentTheme: string;
  constructor(
    private router: Router,
    private $gaService: GoogleAnalyticsService,
    private storageService: StorageService,
    private authService: AuthService,
  ) { }

  private isSevenDaysAgo(timestamp): boolean {
    try {
      timestamp = parseInt(timestamp, 10);

      const currentDate = new Date();

      const sevenDaysAgo = new Date(
        currentDate.getTime() - 14 * 24 * 60 * 60 * 1000,
      );

      const dateFromTimestamp = new Date(timestamp);
      return dateFromTimestamp < sevenDaysAgo;
    } catch (error) {
      // console.log('error====', error);
    }
  }

  trackPageViews(isLogin = false): void {
    this.router.events.subscribe(async (event) => {
      if (event instanceof NavigationEnd) {
        const user = this.storageService.getItem('user');
        if (user) {
          if (Ybug) {
            Ybug.show();
          }
          this.$gaService.pageView(
            isLogin ? '/login' : event.urlAfterRedirects,
            isLogin ? 'User Logged In' : 'Change Route',
            event.urlAfterRedirects,
            {

              user_id: user?.user?.id + user?.user?.email,

            },
          );

          if (user?.user?.is_trial_user) {
            const currentUser = await this.authService.userById(user?.user?.id);

            const isTrialEnd = this.isSevenDaysAgo(currentUser['created_at']);
            if (isTrialEnd)
              this.router.navigateByUrl('/auth/database-error-found');

            return;
          }

          if (
            user?.user?.isNewUser &&
            user?.user?.profileData?.currentRoute &&
            !this.router.url.includes('administration') &&
            !this.router.url.includes('login')
          ) {
            this.renderUserToOnboarding(user?.user);
          }
        } else {
          Ybug ? Ybug.hide() : '';
        }
      }
    });
  }

  renderUserToOnboarding(user: User): void {
    try {
      if (user?.isNewUser === true) {
        this.router.navigateByUrl(user?.profileData?.currentRoute);
      }
    } catch (error) {
      // console.log(error)
    }
  }

  trackEvent(eventName: string, category: string): void {
    const user = this.storageService.getItem('user');
    this.$gaService.event(eventName, category, user?.user?.email);
  }
}
